import { TRANSLATE_TEXT_SUCCESS } from '../constant/actionType';

const initialState = {
  translatedField: '',
  translatedText: '',
  translatedTo: ''
};

const translateReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRANSLATE_TEXT_SUCCESS:
      return {
        translatedField: action.translatedField,
        translatedText: action.data,
        translatedTo: action.translatedTo
      };

    default:
      return state;
  }
};

export default translateReducer;
